import PermissionDenied from "./accessDenied";
import Analytics from "./analytics";
import ForgotPassword from "./auth/ForgotPassword";
import Login from "./auth/Login";
import ResetPassword from "./auth/ResetPassword";
import Verification from "./auth/Verification";
import BroadcastMessage from "./broadcastMessage";
import ManageCustomerSupport from "./customerSupport";
import Dashboard from "./dashboard";
import Dealers from "./dealers";
import DownloadedUsers from "./downloadedUsers";
import EditProfile from "./editProfile";
import IndividualListings from "./individualListings";
import Individuals from "./individuals";
import ManageCms from "./manageCms";
import ManageNotifications from "./manageNotifications";
import MyListings from "./myListings";
import AddVehicle from "./myListings/add";
import MyProfile from "./myProfile";
import Payment from "./payment";
import ProfileDetail from "./ProfileDetail";
import RatingsAndReviews from "./ratingsAndReviews";
import RecievedNotifications from "./recievedNotifications";
import RegionalSpec from "./regionalSpec";
import AddRegionalSpec from "./regionalSpec/add";
import RegisteredUsers from "./registeredUsers";
import ReportAnIssue from "./reportAnIssue";
import Reports from "./reports";
import Stores from "./stores";
import Roles from "./userManagement/role";
import UserList from "./userManagement/userList";
import VehicleDetail from "./vehicleDetail";
import Bookings from "./bookings";
import Categories from "./categories";
import Subscription from "./subscription";
import AddCategory from "./categories/add";
import AddSubscription from "./subscription/add";
import ActiveSubscriptions from "./activeSubscriptions";
import Investment from "./investment";
import InvestorApplications from "./investment/applications";
import ManageAgreement from "./investment/manageAgreement";
import InvestmentPlans from "./investment/investmentPlans";
import RoiDisbursement from "./investment/roiDisbursement";
import AddInvestmentPlan from "./investment/addPlan";
import BookingDetails from "./bookings/details";
import ManagePartners from "./managePartners";
import ManageDiscount from "./manageDiscount";
import AddDiscount from "./manageDiscount/add";
import PartnerDetails from "./managePartners/details";

export default {
  Login,
  Dashboard,
  ForgotPassword,
  ResetPassword,
  Individuals,
  Stores,
  Dealers,
  Verification,
  IndividualListings,
  MyListings,
  AddVehicle,
  RatingsAndReviews,
  VehicleDetail,
  MyProfile,
  DownloadedUsers,
  RegisteredUsers,
  ReportAnIssue,
  Reports,
  Roles,
  UserList,
  BroadcastMessage,
  ProfileDetail,
  EditProfile,
  ManageNotifications,
  RecievedNotifications,
  ManageCms,
  Payment,
  Analytics,
  RegionalSpec,
  AddRegionalSpec,
  PermissionDenied,
  ManageCustomerSupport,
  Bookings,
  Categories,
  Subscription,
  AddCategory,
  AddSubscription,
  ActiveSubscriptions,
  Investment,
  InvestorApplications,
  ManageAgreement,
  InvestmentPlans,
  RoiDisbursement,
  AddInvestmentPlan,
  BookingDetails,
  ManagePartners,
  ManageDiscount,
  AddDiscount,
  PartnerDetails,
};
